import { render, staticRenderFns } from "./MenuReward.vue?vue&type=template&id=16d66f37&scoped=true&"
import script from "./MenuReward.vue?vue&type=script&lang=js&"
export * from "./MenuReward.vue?vue&type=script&lang=js&"
import style0 from "./MenuReward.vue?vue&type=style&index=0&id=16d66f37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d66f37",
  null
  
)

export default component.exports